import { GtkmActionTypes } from './action-types';
import { GtkmAnimationState } from './types';
export const initialGtkmState = {
  animationState: GtkmAnimationState.NotDisplayed,
  showingErrorModal: false,
  animationShowingCount: 0,
  hasDomainChangedInDomainStep: false,
  normalisedDomain: ''
};
const gtkmReducer = (state = initialGtkmState, action) => {
  switch (action.type) {
    case GtkmActionTypes.SetAnimationStart:
      return Object.assign({}, state, {
        animationState: GtkmAnimationState.Started
      });
    case GtkmActionTypes.SetAnimationStop:
      return Object.assign({}, state, {
        animationState: GtkmAnimationState.Stopped
      });
    case GtkmActionTypes.SetShowingErrorModal:
      return Object.assign({}, state, {
        showingErrorModal: action.showingErrorModal
      });
    case GtkmActionTypes.SetAnimationNotDisplayed:
      return Object.assign({}, state, {
        animationState: GtkmAnimationState.NotDisplayed
      });
    case GtkmActionTypes.SetAnimationShowingCount:
      return Object.assign({}, state, {
        animationShowingCount: action.animationShowingCount
      });
    case GtkmActionTypes.SetHasDomainChangedInDomainStep:
      return Object.assign({}, state, {
        hasDomainChangedInDomainStep: action.hasDomainChangedInDomainStep
      });
    case GtkmActionTypes.SetNormalisedDomain:
      return Object.assign({}, state, {
        normalisedDomain: action.normalisedDomain
      });
    default:
      return state;
  }
};
export default gtkmReducer;